import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import WeeklySignTranslation from '@/repositories/data/weeklysign/WeeklySignTranslation';

export default class WeeklySignTranslationRepository extends BaseCrudRepository<
    number,
    WeeklySignTranslation,
    WeeklySignTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/weekly-sign-translation/');
    }
}
